import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
const store = new Vuex.Store({
  state:{
    currentPage:sessionStorage.getItem('currPage')||'/tree',
    userInfo:sessionStorage.getItem('userInfo')?JSON.parse(sessionStorage.getItem('userInfo')):null
  },
  mutations:{
    changePage(state,page){
      sessionStorage.setItem('currPage',page)
      state.currentPage = page
    },
    updateUserInfo(state,userInfo){
      sessionStorage.setItem('userInfo',userInfo)
      // state.userInfo = userInfo
      if(userInfo){
        state.userInfo = JSON.parse(userInfo)
      }else{
        state.userInfo = null
      }
    }
  },
  actions:{
    
  },
  modules:{

  }
})

export default store


// WEBPACK FOOTER //
// ./src/store/index.js